import React, { useEffect, useState } from 'react';
import Chart from './chart';

import { Card, Modal } from 'tea-component';
import './index.scss';
import BubbleCommon, {
  keywordCorrelationCloudTips,
} from '@/pages/opinion/components/BubbleCommon';
import { useHistory } from 'react-router-dom';
import KeywordCorrelationFilter from '../filter/cloud-filter';
import { downloadAction } from '@/pages/opinion/components/DownloadCommon/download-page';
import { getWordCloud } from '@/pages/opinion/services';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'umi';
import { fullIcon } from '@/pages/opinion/constants/chart';

export default function Component(props: any) {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const {
    keepParams = {},
    keywordCorrelationFilter = {},
    language = 'origin',
  } = props;

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [saveParams, setSaveParams] = useState<any>({});

  const [keywordCloudFilter, setKeywordCloudFilter] = useState<{
    correlation: string | number;
    frequency: string | number;
  }>({
    correlation: '',
    frequency: 3,
  });

  const fetchData = async () => {
    const {
      edition_unified_id,
      id_type,
      entity_type,
      start_time,
      end_time,
      date_type,
      sentiment,
      language,
    } = keepParams;

    const { pos, distance } = keywordCorrelationFilter;
    const { frequency, correlation } = keywordCloudFilter;

    if (!edition_unified_id) return;

    setLoading(true);

    const params: any = {
      edition_unified_id,
      id_type,
      entity_type,
      start_time,
      end_time,
      date_type,
      sentiments: sentiment,
      languages: language,
      top_n: 20,
      ...keywordCloudFilter,
    };

    if (pos !== 'all') params.pos = pos;
    else delete params.pos;
    if (distance !== 'all') params.distance = Number(distance);
    else delete params.distance;
    params.correlation = correlation !== '' ? correlation : -9999;
    if (params.frequency !== '') params.frequency = frequency;
    else delete params.frequency;

    try {
      setSaveParams(params);
      const data = await getWordCloud(params);

      setApiError(false);
      if (Array.isArray(data) && data.length > 0) {
        setData(data);
        setNoData(false);
      } else {
        setNoData(true);
      }

      setLoading(false);
    } catch {
      setApiError(true);
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [keepParams, keywordCorrelationFilter, keywordCloudFilter]);

  useEffect(() => {
    console.log('keepParams', keepParams);
  }, [keepParams]);

  useEffect(() => {
    console.log('keywordCorrelationFilter', keywordCorrelationFilter);
  }, [keywordCorrelationFilter]);

  useEffect(() => {
    console.log('keywordCloudFilter', keywordCloudFilter);
  }, [keywordCloudFilter]);

  const [visible, setVisible] = useState(false);

  const open = () => setVisible(true);
  const close = () => setVisible(false);

  const operations = apiError || noData || loading ? [] : [fullIcon];

  const hasDownload = !(apiError || noData || loading);

  return (
    <>
      <CardCommon
        className="dbo-correlation-cloudbox"
        operations={operations}
        handleOperationsOnClick={() => {
          open();
        }}
        handleDownloadOnClick={() => {
          downloadAction({
            simpleName: 'Keyword Correlation',
            // sheetName: ['Anchor Words', 'First Correlation Words', 'Second Correlation Words'],
            sheetName: [
              {
                name: 'Anchor Words',
                addOn: {
                  words_type: 'head',
                  need_link: true,
                  link_top_n: 50,
                  total: 20,
                  page_size: 20,
                  top_n: 20,
                },
                replaceName: 'Keyword Correlation',
              },
              {
                name: 'First Correlation Words',
                addOn: {
                  words_type: 'second',
                  total: 100,
                  page_size: 100,
                  top_n: 100,
                },
                replaceName: 'Keyword Correlation',
              },
              {
                name: 'Second Correlation Words',
                addOn: {
                  words_type: 'third',
                  total: 100,
                  page_size: 100,
                  top_n: 100,
                },
                replaceName: 'Keyword Correlation',
              },
            ],
            // sheetName: 'Anchor Words',
            align: 'center',
            downLoadParams: {
              ...saveParams,
              __language: language, // 新增用不到的参数
              page: 1,
              noChangePageSize: true,
            },
            downloadFunc: 'getWordDownload',
          });
        }}
        hasDownload={hasDownload}
        title={
          <BubbleCommon tipsMap={keywordCorrelationCloudTips}>
            {formatMessage({ id: 'Cloud' })}
          </BubbleCommon>
        }
      >
        <>
          <KeywordCorrelationFilter
            onChange={(key, value) => {
              setKeywordCloudFilter({
                ...keywordCloudFilter,
                [key]: value,
              });
            }}
          ></KeywordCorrelationFilter>

          <CardCommon
            contentCard
            loading={loading}
            empty={noData}
            emptyHeight={370}
            loadingHeight={370}
          >
            <Chart data={data} language={language} height={370} />
          </CardCommon>
        </>
      </CardCommon>

      <Modal
        maskClosable={true}
        visible={visible}
        onClose={close}
        style={{
          width: '80%',
          height: '80%',
          left: '10%',
          top: '10%',
          borderRadius: 4,
        }}
        className="dbo-correlation-cloud-modal"
      >
        <CardCommon
          className="modal-echarts-card"
          loading={loading}
          empty={noData}
        >
          <Chart zoom={1} data={data} language={language} height={'100%'} />
        </CardCommon>
      </Modal>
    </>
  );
}
